import { render, staticRenderFns } from "./RegistrationResult.vue?vue&type=template&id=772eacec"
import script from "./RegistrationResult.vue?vue&type=script&lang=ts"
export * from "./RegistrationResult.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationResult.vue?vue&type=style&index=0&id=772eacec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports